import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["progressBar", "progressLegend", "progressText"]
  }

  static get values() {
    return { pending: Boolean, type: String, paid: Boolean, available: Boolean, id: Number }
  }

  connect() {
    let _this = this

    if (this.pendingValue === false && this.typeValue != "bulk-searches") {
      return
    }

    if ((this.paidValue || this.availableValue) && this.typeValue == "bulk-searches") {
      return
    }

    let updateProgress = setInterval(function () {
      fetch(`/${_this.typeValue}/${_this.idValue}/progress?t=${new Date().getTime()}`, {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      })
        .then(response => {
          if (response.ok) {
            return response.json()
          }

          // If the bulk was deleted, for example, the request will return a 404.
          // In such case, not need to continue polling for the progress.
          clearInterval(updateProgress)
        })
        .then(json => {
          const { percentage, processed_rows } = json.progress

          if (typeof json.has_errors != undefined && json.has_errors == true) {
            clearInterval(updateProgress)

            if (_this.hasProgressBarTarget) {
              _this.reload()
            }
          } else if (percentage === 100) {
            clearInterval(updateProgress)

            if (App.isTabVisible()) {
              if (_this.hasProgressBarTarget) {
                _this.progressBarTarget.style.width = "100%"
              }
            }

            // If a destination was provided, take the user to that destination.
            // Else, reload the current page.
            if (_this.destinationValue) {
              _this.goToDestination(_this.destinationValue)
            } else {
              _this.reload()
            }
          } else if (percentage === 90) {
            if (_this.hasProgressLegendTarget) {
              _this.progressLegendTarget.innerHTML = i18n.t("js.back.bulks.loading.generating_files")
            }

            if (_this.hasProgressBarTarget) {
              _this.progressBarTarget.classList.add("is-loading")
            }
          } else {
            if (_this.hasProgressTextTarget) {
              _this.progressTextTarget.innerHTML = processed_rows
            }

            if (_this.hasProgressBarTarget) {
              _this.progressBarTarget.style.width = `${percentage}%`
            }
          }
        })
        .catch(_err => {
          console.warn(`Error while updating the progress bar of ${_this.idValue}`)
        })
    }, 1500)
  }

  reload() {
    setTimeout(location.reload.bind(location), 500)
  }

  goToDestination(destination) {
    setTimeout(Turbo.visit(destination), 500)
  }
}
